<template>
	<div class="ic-launcher-wrapper"
		 :class="{ 'has-launcher-text': $slots['launcher-text'] || launcherText }">
		<div v-if="showLauncher && !isShortScreen"
			 class="ic-launcher"
			 :class="{ opened: isOpen }"
			 @click.prevent="isOpen ? close() : openAndFocus()">

			 <div class="overlay"></div>

			<template v-if="isOpen">
				<span class="ic-close-icon">
					<slot name="launcher-close">
						<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 448 512">
							<path
								  d="M212.7 331.3c6.2 6.2 16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4 75.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l160 160z" />
						</svg>
					</slot>
				</span>
			</template>
			<template v-else>
				<span class="ic-open-icon">
					<slot name="launcher-open">
						<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 448 512">
							<path
								  d="M212.7 148.7c6.2-6.2 16.4-6.2 22.6 0l160 160c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 182.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160z" />
						</svg>
					</slot>
				</span>
				<span class="ic-open-text hidden md:block" v-if="$slots['launcher-text'] || launcherText">
					<slot name="launcher-text">
						{{ launcherText }}
					</slot>
				</span>
			</template>

		</div>

		<Teleport to="#tdapp">
			<IntercomPanel
						v-if="!lazy || lazy && isOpen"
						:is-open="isOpen"
						:title="title"
						@close="close">

				<template v-slot:header>
					<slot name="header"> </slot>
				</template>

				<slot v-if="isOpen"></slot>

			</IntercomPanel>
		</Teleport>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IntercomPanel from './Panel.vue'
import Teleport from 'vue2-teleport';
import { useMediaQuery } from '@vueuse/core';

const isWideScreen = useMediaQuery('(min-width: 720px)');
const isShortScreen = useMediaQuery('(max-height: 600px)');

export default defineComponent({
	name: "IntercomLauncher",
	components: {
		IntercomPanel,
		Teleport
	},
	props: {
		open: Function,
		title: String,
		lazy: Boolean,
		launcherText: {
			type: String,
			default: null
		},
		showLauncher: {
			type: Boolean,
			default: true
		},
		showCloseButton: {
			type: Boolean,
			default: true
		},
	},
	data() {
		return {
			isOpen: false
		}
	},
	methods: {
		openAndFocus() {
			this.isOpen = true;
			this.$emit('open');
			document.body.classList.add('modal-open');
		},
		close() {
			this.isOpen = false;
			this.$emit('close')
			document.body.classList.remove('modal-open');
		}
	},
	setup() {
		return { isWideScreen, isShortScreen }
	}
})
</script>

<style scoped>
.ic-launcher-wrapper {
	width: auto;
	height: 60px;
	z-index: 20;
	color: #000;
	position: fixed;
	right: 25px;
	bottom: 25px;
	box-shadow: none;
}

@media (min-width: 768px) {
	.ic-launcher-wrapper.has-launcher-text .ic-launcher {
		border-radius: 50px;
	}

	.ic-launcher-wrapper.has-launcher-text .ic-launcher:not(.opened) {
		padding: 0 20px;
	}

	.ic-launcher .overlay {
		box-shadow: 0px 0px 200px 200px rgb(0 0 0 / 16%);
	}
}

.ic-launcher {
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	justify-content: center;
	background: linear-gradient(to bottom, hsl(42 100% 69% / 1) 26%, hsl(45 100% 41% / 1));
	border-radius: 50%;
	position: relative;
	cursor: pointer;
	min-width: 60px;
	height: 60px;
	transition: background 0.2s ease-in-out;
}

.ic-launcher .overlay {
	content: '';
	position: fixed;
	display: block;
	bottom: 25px;
	right: 25px;
	width: 60px;
	z-index: -1;
	border-radius: 50%;
	transition: box-shadow 0.2s ease-in-out;
	box-shadow: 0px 0px 100px 80px rgb(132 132 132 / 14%);
}

.ic-launcher .ic-open-icon,
.ic-launcher .ic-close-icon {
	min-width: 25px;
	min-height: 25px;
	margin: 0 10px;
	fill: white;
	transform-origin: center;
	transition: opacity 100ms ease-in-out, transform 100ms ease-in-out;
}

.ic-launcher .ic-open-icon {
	box-sizing: border-box;
	opacity: 1;
}

.ic-launcher .ic-open-text {
	font-size: 18px;
	margin: 0 10px;
}

.ic-launcher.opened .ic-open-icon {
	transform: rotate(0deg);
	opacity: 1;
}

.ic-launcher.opened .ic-close-icon {
	transform: rotate(360deg);
	opacity: 1;
}

.ic-launcher.opened .overlay {
	box-shadow: 0px 0px 400px 250px rgba(148, 149, 150, 0.2);
}
</style>
